import React, { useRef, useState } from "react";

const VideoComponent: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [playing, setPlaying] = useState(false);

  const togglePlay = () => {
    if (!videoRef.current) return;

    if (playing) {
      videoRef.current.pause();
      setPlaying(false);
    } else {
      videoRef.current.play().catch((e) => console.log("Play failed:", e));
      setPlaying(true);
    }
  };

  return (
    <section style={{ width: "100%", marginTop: "40px", padding: "0" }}>
      <div
        style={{
          position: "relative",
          maxWidth: "1280px",
          margin: "clamp(60px, 12vw, 30px) auto",
          borderRadius: "clamp(12px, 3vw, 18px)",
          overflow: "hidden",
          boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
          padding: "1px",
        }}
      >
        <video
          ref={videoRef}
          loop
          playsInline
          poster="/video-thumbnail.jpg.webp" // Add your thumbnail image here
          style={{
            width: "100%",
            height: "clamp(220px, 55vw, 600px)",
            objectFit: "cover",
            display: "block",
          }}
        >
          <source src="/video1.mp4" type="video/mp4" />
        </video>

        {/* Gradient overlay - subtle darkening at bottom */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(to top, rgba(0,0,0,0.60) 0%, rgba(0,0,0,0.15) 60%, transparent 100%)",
            pointerEvents: "none",
          }}
        />

        {/* Click-to-play/pause overlay */}
        <div
          onClick={togglePlay}
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            zIndex: 10,
            transition: "opacity 0.4s ease",
            opacity: playing ? 0 : 1,
            background: playing ? "transparent" : "rgba(0,0,0,0.35)",
          }}
        >
          <div
            style={{
              fontSize: "clamp(48px, 12vw, 110px)",
              color: "white",
              textShadow: "0 4px 12px rgba(0,0,0,0.7)",
              lineHeight: 1,
              userSelect: "none",
              pointerEvents: "none",
            }}
          >
            {playing ? "❚❚" : "▶"}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoComponent;
